import * as React from 'react';
import ResetPassword from '@/pages/ResetPassword/components/ResetPassword';
import { useNavigate } from 'react-router';
import { FullScreenLoading } from '@/components/displays/FullScreenLoading';
import { useAuth } from '@/providers/auth/AuthProvider';
import { useNotifications } from '@toolpad/core';
import { capture } from '@/handlers/error';
import { useTranslation } from 'react-i18next';

export default function ResetPasswordPage() {
    const { resetPassword } = useAuth();
    const navigate = useNavigate();
    const notifications = useNotifications();
    const { t } = useTranslation();

    // params
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const email = params.get('email');
    const token = params.get('token');

    const handleReset = async (password: string) => {
        if (email && token) {
            try {
                await resetPassword(email, token, password);
                notifications.show(t('onboarding.resetPassword.success'), { severity: 'success', autoHideDuration: 5000 });
                navigate('/welcome');
            } catch (error) {
                capture(error);
                notifications.show(error instanceof Error ? error.message : `${error}`, { severity: 'error', autoHideDuration: 5000 });
            }
        }
    };

    return email && token ? <ResetPassword onSignIn={() => navigate('/welcome')} onReset={handleReset} /> : <FullScreenLoading />;
}
